export const ERR_OK = 1000      //成功返回值

export const ERR_NO = 1003      //错误返回值

export const ERR_LOGIN = 1001      //token失效
